import React from 'react'
import Link from 'redux-first-router-link'
import { LOGIN_PAGE } from 'constants/pages'
import { button } from '@groovehq/internal-design-system/lib/styles/elements'
import logo from 'assets/groove_logo_v2.svg'

import ProgressBar from '../../ProgressBar'

import { styles } from './styles'

const Variant4 = ({ page, children }) => {
  const [loaded, progress] = ProgressBar.useProgress(page)

  if (!loaded) return null

  return (
    <div className="grui flex">
      <div className="grui flex-grow">
        <div css={styles.header}>
          <ProgressBar progress={progress} />
          <div css={styles.heading}>
            <div css={styles.logo}>
              <img src={logo} alt="GrooveHQ" />
            </div>
            <div css={styles.login}>
              <span>Already have an account?</span>{' '}
              <Link
                to={{ type: LOGIN_PAGE }}
                css={button.styles.link}
                className="grui underline"
              >
                Log in
              </Link>
            </div>
          </div>
        </div>
        <div className="grui px-10 pb-15">{children}</div>
      </div>
    </div>
  )
}

export default Variant4
